/* eslint-disable react/jsx-key */
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectFileIndex, selectFilesToUpload, selectIgnoreInfo, selectResolveHost, selectUploadState, selectWorkspaceSelected } from 'store/ManageEditCreate/selectors';
import Wrapper from './styled';
import Body from './components/Body';
import Header from './components/Header';
import { uploadFile } from 'Screens/Contextualization/ManageEditCreate/actions/Actions';
import { selectProcessingQueueIsExpanded } from 'store/FileUploaderContext/selector';

const FileUploadContext = () => {
  const showBody = useSelector(selectProcessingQueueIsExpanded);
  const uploadState = useSelector(selectUploadState);
  const files = useSelector(selectFilesToUpload);
  const fileIndex = useSelector(selectFileIndex);
  const ignoreInfo = useSelector(selectIgnoreInfo);
  const resolveHost = useSelector(selectResolveHost);
  const workspace = useSelector(selectWorkspaceSelected);
  const dispatch = useDispatch();

  useEffect(() => {
    if (uploadState === 'PROCESSED' && fileIndex >= 0) {
      const params = [
        { name: 'file', value: files[fileIndex] },
        { name: 'ignore_info', value: ignoreInfo },
        { name: 'resolve_hostname', value: resolveHost }
      ];

      dispatch(uploadFile(params, workspace));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, uploadState]);

  return (
    <Wrapper>
      <Header showBody={ showBody } />
      {showBody && <Body /> }
    </Wrapper>
  );
};

export default FileUploadContext;
